import { CancelToken } from '../cancel/CancelError';

/**
 * Represents the props passed to a 'loader' function.
 * @public
 */
export interface ILoaderProps {
  cancelToken?: CancelToken;
}

/**
 * Represents a 'loader' function, which is a function which takes some
 * async control props and returns a promise that will produce a result.
 * @public
 */
export interface ILoader<TResult> {
  (props?: ILoaderProps): Promise<TResult>;
}

/**
 * Represents a standard form of function which modifies an existing loader
 * and produces a new loader.
 * @public
 */
export interface ILoaderDecorator<TOptions> {
  <TResult>(load: ILoader<TResult>, options: TOptions): ILoader<TResult>;
}

/**
 * Composes two loader decorators together to create a new one which applies
 * both in order and takes the union of all props.
 * @public
 */
export function composeLoaders<TOuterOptions, TInnerOptions>(
  outer: ILoaderDecorator<TOuterOptions>,
  inner: ILoaderDecorator<TInnerOptions>
): ILoaderDecorator<TOuterOptions & TInnerOptions> {
  return <TResult>(load: ILoader<TResult>, options: TOuterOptions & TInnerOptions) => {
    return outer(inner(load, options), options);
  };
}
